import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/3 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold text-lg"
}
const _hoisted_6 = {
  key: 1,
  class: "font-semibold text-lg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "w-full mb-4" }
const _hoisted_11 = { class: "w-full mb-4" }
const _hoisted_12 = { class: "w-full flex flex-row space-x-2" }
const _hoisted_13 = {
  key: 0,
  class: "w-1/2 mb-4"
}
const _hoisted_14 = { class: "w-1/2 mb-4" }
const _hoisted_15 = { class: "w-full mb-4" }
const _hoisted_16 = { class: "w-full mb-4" }
const _hoisted_17 = { class: "flex flex-row justify-between items-center" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "relative flex flex-row items-center justify-center ml-4 mr-4" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "ml-4"
}
const _hoisted_22 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full",
  style: {"background":"#2a292978"}
}
const _hoisted_23 = { class: "flex flex-col bg-white h-auto rounded-2xl shadow p-8" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-primary" }, "Are you sure you want to create this hiring fee?")
], -1)
const _hoisted_25 = { class: "flex justify-end items-end space-x-1 mt-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, " Confirm", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_NewCurrencyField = _resolveComponent("NewCurrencyField")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Add hiring fee "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "Edit hiring fee")),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.company_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company_id) = $event)),
                    label: "Select a company",
                    options: _ctx.companies,
                    typeInput: "text",
                    name: "company_id",
                    disabled: _ctx.isEditing,
                    isError: _ctx.fieldErrors.company_id
                  }, null, 8, ["modelValue", "options", "disabled", "isError"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_TextField, {
                    name: "title",
                    label: "Title",
                    typeInput: "text",
                    isError: _ctx.fieldErrors.title
                  }, null, 8, ["isError"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.loadingField)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_NewCurrencyField, {
                          modelValue: _ctx.amount,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.amount) = $event)),
                          hiddenCurrencySymbol: true
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_DropDown, {
                      modelValue: _ctx.currency,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currency) = $event)),
                      label: "Select a currency",
                      options: _ctx.currencies,
                      typeInput: "text",
                      name: "currency",
                      isError: _ctx.fieldErrors.currency
                    }, null, 8, ["modelValue", "options", "isError"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_TextField, {
                    name: "first_name",
                    label: "First name",
                    typeInput: "text",
                    isError: _ctx.fieldErrors.first_name
                  }, null, 8, ["isError"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_TextField, {
                    name: "last_name",
                    label: "Last name",
                    typeInput: "text",
                    isError: _ctx.fieldErrors.last_name
                  }, null, 8, ["isError"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "rounded-full border-2 border-primary text-primary py-4 px-6"
                }, " Cancel "),
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                  disabled: !_ctx.meta.valid,
                  class: _normalizeClass(["disabled:opacity-50 disabled:cursor-not-allowed", {
                'btn-filled-lg': !_ctx.loading,
                'btn-filled-lg-loading': _ctx.loading,
              }])
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_Spinner, {
                          key: 0,
                          color: "white",
                          height: "6",
                          width: "6",
                          border: "2"
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.isEditing ? "Edit" : "Create"), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, "Loading..."))
                  ])
                ], 10, _hoisted_18)
              ])
            ]),
            (_ctx.displayConfirm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        class: "rounded-xl border-2 border-primary text-primary py-2 px-6",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.displayConfirm = !_ctx.displayConfirm))
                      }, " Cancel "),
                      _createElementVNode("button", {
                        class: "rounded-xl border-2 border-primary text-primary py-2 px-6 bg-primary",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.confirmHiringFee && _ctx.confirmHiringFee(...args)))
                      }, _hoisted_27)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28))
      : _createCommentVNode("", true)
  ]))
}